import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Container,
  Input,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { showModal } from '../../actions';
import { showConfirmationModal } from '../../actions/App';

import { APIgetUsers } from '../../api/User';

import AdminUsersHeader from '../../components/Admin/Users/Header';
import AdminUsersList from '../../components/Admin/Users/List';
import AdminUsersFooter from '../../components/Admin/Users/Footer';
import AdminBulkActionsSelector from '../../components/Admin/BulkActionsSelector';
import AdminUsersFiltersSelector from '../../components/Admin/Users/FilterSelector';
import AdminUsersFiltersSelected from '../../components/Admin/Users/FiltersSelected';
import AdminUsersLimitWarning from '../../components/Admin/Users/LimitWarning';

import { getVisibleItemsText } from '../../helpers';
import { getUserSetting } from '../../helpers/Settings';
import { handleComponentParams, handleURLParams } from '../../helpers/URLParams';
import { sendWelcomeEmails } from '../../helpers/Users';

import ErrorBoundary from '../../components/ErrorBoundary';
import HelpIcon from '../../components/HelpIcon';

const FILTER_CONFIG = {
  selectedUserActivationStatuses: {
    hasAll: true,
    allValue: 'all',
  },
  selectedRoles: {
    hasAll: true,
    allValue: 'all',
  },
};
class AdminUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedUsers: [],
      users: [],
      usersTotal: 0,
      usersActive: 0,
      usersInactive: 0,
      usersDeactivated: 0,
      activationStatuses: {},
      selectedUserActivationStatuses: ['all'],
      selectedRoles: [],
      counts: {},
      search: '',
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      orderBy: 'created_at',
      order: 'desc',
      loading: true,
    };

    this.searchRef = React.createRef();

    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangePerPage = this.handleChangePerPage.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleClearSearch = this.handleClearSearch.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleDeactivate = this.handleDeactivate.bind(this);
    this.handleActivate = this.handleActivate.bind(this);
    this.handleSelectUser = this.handleSelectUser.bind(this);
    this.handleSendWelcomeEmails = this.handleSendWelcomeEmails.bind(this);
    this.handleSelectAction = this.handleSelectAction.bind(this);
    this.isBulkActionDisabled = this.isBulkActionDisabled.bind(this);
    this.loadUsers = this.loadUsers.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
      orderBy, order, selectedUserActivationStatuses, selectedRoles,
    } = this.state;

    handleComponentParams(
      false,
      ['page', 'perPage', 'orderBy', 'order', 'search', 'selectedUserActivationStatuses', 'selectedRoles'],
      prevProps,
      this.setState.bind(this),
      () => { this.loadUsers(); },
      {
        perPage: getUserSetting('admin_per_page') || 20,
        orderBy,
        order,
        selectedUserActivationStatuses,
        selectedRoles,
      },
    );
  }

  componentDidMount() {
    const { history, location } = this.props;
    const {
      perPage,
      selectedUserActivationStatuses, selectedRoles, orderBy, order, search,
    } = this.state;

    const queryParams = new URLSearchParams(location.search);

    if (!queryParams.get('selectedUserActivationStatuses')) {
      handleURLParams({ selectedUserActivationStatuses }, history);
    }
    if (!queryParams.get('orderBy')) {
      handleURLParams({ orderBy }, history);
    }
    if (!queryParams.get('order')) {
      handleURLParams({ order }, history);
    }

    handleComponentParams(
      true,
      ['page', 'perPage', 'orderBy', 'order', 'search', 'selectedUserActivationStatuses', 'selectedRoles'],
      null,
      this.setState.bind(this),
      () => { this.loadUsers(); },
      {
        perPage,
        orderBy,
        order,
        search,
        selectedUserActivationStatuses,
        selectedRoles,
      },
    );
  }

  loadUsers(silent = false) {
    const {
      selectedUserActivationStatuses,
      selectedRoles,
      search,
      page,
      perPage,
      orderBy,
      order,
    } = this.state;

    const filteredSelectedUserActivationStatuses = selectedUserActivationStatuses.filter(i => (i !== 'all'));
    const filteredSelectedRoles = selectedRoles.filter(i => (i !== 'all'));

    if (!silent) {
      this.setState({ loading: true });
    }

    APIgetUsers({
      search,
      page,
      per_page: perPage,
      order_by: orderBy,
      order,
      activationStatuses: filteredSelectedUserActivationStatuses,
      role: filteredSelectedRoles,
    }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState(prevState => ({
          loading: false,
          users: data.data,
          selectedUsers: prevState.selectedUsers
            .map(su => data.data.find(u => u.uuid === su.uuid))
            .filter(Boolean),
          usersTotal: data.meta.total,
          usersActive: data.meta.counts.active,
          usersInactive: data.meta.counts.inactive,
          usersDeactivated: data.meta.counts.deactivated,
          activationStatuses: data.meta.activation_statuses,
          counts: data.meta.counts,
        }));
      }
    });
  }

  handleChangeOrder(orderBy, order) {
    const { history } = this.props;

    handleURLParams({ orderBy, order, page: 1 }, history);
    this.setState({
      orderBy,
      order,
      page: 1,
    });
  }

  handleChangePage(page) {
    const { history } = this.props;

    handleURLParams({ page }, history);
    this.setState({
      page,
    });
  }

  handleChangePerPage(perPage) {
    const { history } = this.props;

    handleURLParams({ page: 1, perPage }, history);
    this.setState({
      page: 1,
      perPage: Number(perPage),
    });
  }

  handleChangeSearch(e) {
    const { value } = e.target;
    this.setState({ search: value });
  }

  handleClearSearch(e) {
    e.preventDefault();
    this.searchRef.value = '';

    const { history } = this.props;

    handleURLParams({ search: '', page: 1 }, history);

    this.setState({
      search: '',
      page: 1,
    });
  }

  handleChangeFilter(e) {
    const {
      name,
      checked,
      value,
      type,
    } = e.target;

    const { history } = this.props;

    const config = FILTER_CONFIG[name] || {};
    const { [name]: stateValue = [] } = this.state;
    let newValue = [...stateValue];

    if (type === 'checkbox') {
      if (config.hasAll) {
        if (!value) {
          newValue = [];
        } else if (value === config.allValue) {
          newValue = [config.allValue];
        } else if (checked) {
          newValue = [...newValue.filter(i => i !== config.allValue), value];
        } else {
          newValue = newValue.filter(i => i !== value);
        }

        if (newValue.length === 0) {
          newValue = [config.allValue];
        }
      } else if (checked) {
        newValue = [...new Set([...newValue, value])];
      } else {
        newValue = newValue.filter(i => i !== value);
      }
    }

    handleURLParams({ [name]: newValue, page: 1 }, history);

    this.setState({
      [name]: newValue,
      page: 1,
    });
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      e.preventDefault();

      const { search } = this.state;
      const { history } = this.props;

      handleURLParams({ search, page: 1 }, history);

      this.setState({ page: 1 });
    }
  }

  handleDeactivate(users) {
    const { openUserDeactivateModal } = this.props;

    openUserDeactivateModal({
      className: 'modal-deactivate-user',
      users,
      backdrop: true,
      afterDeactivateUsers: () => {
        this.loadUsers(true);
      },
    });
  }

  handleActivate(users) {
    const { openUserActivateModal } = this.props;

    openUserActivateModal({
      className: 'modal-activate-user',
      users,
      backdrop: true,
      afterActivateUsers: () => {
        this.loadUsers(true);
      },
    });
  }

  handleSelectUser(e) {
    const {
      value,
      checked,
    } = e.target;
    const {
      selectedUsers,
      users,
    } = this.state;

    if (value === 'all') {
      if (checked) {
        this.setState({ selectedUsers: users });
      } else {
        this.setState({ selectedUsers: [] });
      }
      return;
    }

    if (selectedUsers.find(user => user.uuid === value)) {
      this.setState(prevState => ({
        selectedUsers: prevState.selectedUsers.filter(su => su.uuid !== value),
      }));
    } else {
      this.setState(prevState => ({
        selectedUsers: [...prevState.selectedUsers, users.find(u => u.uuid === value)],
      }));
    }
  }

  handleSendWelcomeEmails(userUuids, callback = () => {}) {
    const {
      intl,
      openConfirmationModal,
    } = this.props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Send welcome {usersCount, plural, one {email} other {emails}}?' }, {
        usersCount: userUuids.length,
      }),
      text: intl.formatMessage({
        defaultMessage: 'You are about to send a welcome email to {usersCount} {usersCount, plural, one {user} other {users}}. Upon login, their {usersCount, plural, one {account} other {accounts}} will be activated.',
      }, {
        usersCount: userUuids.length,
      }),
      onConfirm: () => (
        sendWelcomeEmails(userUuids).then(() => {
          this.setState({ selectedUsers: [] });
          this.loadUsers(true);
          callback();
        })
      ),
    };
    openConfirmationModal(modalParams);
  }

  handleSelectAction(action, callback) {
    const { selectedUsers } = this.state;

    if (action === 'send-activation-email') {
      this.handleSendWelcomeEmails(selectedUsers.map(u => u.uuid), callback);
    }

    if (action === 'activate-users') {
      this.handleActivate(selectedUsers.filter(u => u.deactivated_at), callback);
    }

    if (action === 'deactivate-users') {
      this.handleDeactivate(selectedUsers.filter(u => !u.deactivated_at), callback);
    }
  }

  isBulkActionDisabled(action) {
    const { selectedUsers } = this.state;

    if (selectedUsers.length === 0) {
      return false;
    }

    if (action === 'activate-users') {
      return selectedUsers.every(user => !user.deactivated_at);
    }

    if (action === 'deactivate-users') {
      return selectedUsers.every(user => !!user.deactivated_at);
    }

    return false;
  }

  render() {
    const {
      intl,
    } = this.props;
    const {
      selectedUsers,
      search,
      page,
      perPage,
      usersTotal,
      usersActive,
      usersInactive,
      usersDeactivated,
      activationStatuses,
      selectedUserActivationStatuses,
      selectedRoles,
      counts,
      loading,
    } = this.state;

    return (
      <div className="settings-inner-content">
        <div className="main-content">
          <Container fluid>
            <AdminUsersHeader
              usersTotal={usersTotal}
              usersVisible={getVisibleItemsText(page, perPage, usersTotal)}
              usersActive={usersActive}
              usersInactive={usersInactive}
              usersDeactivated={usersDeactivated}
              loading={loading}
            />
            <p>
              {intl.formatMessage({ defaultMessage: 'Invite and manage your workspace users and their permissions.' })}
              <HelpIcon
                id="help-users"
                url="https://help.stockpress.co/en/articles/5937841-inviting-users-to-your-workspace"
              />
            </p>
            <AdminUsersLimitWarning />
            <>
              <div className="actions-wrapper">
                <div className="users-actions">
                  <AdminUsersFiltersSelected
                    userActivationStatuses={activationStatuses}
                    selectedUserActivationStatuses={selectedUserActivationStatuses}
                    selectedRoles={selectedRoles}
                    handleChangeFilter={this.handleChangeFilter}
                  />
                  <AdminBulkActionsSelector
                    actions={[
                      {
                        id: 'send-activation-email',
                        name: intl.formatMessage({ defaultMessage: 'Send activation email' }),
                      },
                      {
                        id: 'deactivate-users',
                        name: intl.formatMessage({ defaultMessage: 'Deactivate' }),
                      },
                      {
                        id: 'activate-users',
                        name: intl.formatMessage({ defaultMessage: 'Re-activate' }),
                      },
                    ]}
                    disabled={selectedUsers.length === 0}
                    isApplyDisabled={this.isBulkActionDisabled}
                    handleSelectAction={this.handleSelectAction}
                  />
                </div>
                <div className="position-relative inline-search users-search">
                  <AdminUsersFiltersSelector
                    counts={counts}
                    userActivationStatuses={activationStatuses}
                    selectedUserActivationStatuses={selectedUserActivationStatuses}
                    selectedRoles={selectedRoles}
                    handleChangeFilter={this.handleChangeFilter}
                    disabled={loading}
                  />
                  <Input
                    id="user-search"
                    name="user-search"
                    bsSize="sm"
                    innerRef={(ref) => { this.searchRef = ref; }}
                    placeholder={intl.formatMessage({ defaultMessage: 'Type name or email and press Enter to search' })}
                    disabled={loading}
                    onChange={this.handleChangeSearch}
                    onKeyPress={this.handleKeyPress}
                    value={search}
                  />
                  {search && (
                    <a
                      href="#clear"
                      className="search-clear"
                      onClick={this.handleClearSearch}
                    >
                      <i className="fas fa-times" />
                    </a>
                  )}
                </div>
              </div>
              <ErrorBoundary>
                <AdminUsersList
                  {...this.state}
                  handleChangeOrder={this.handleChangeOrder}
                  handleDeactivate={this.handleDeactivate}
                  handleActivate={this.handleActivate}
                  loadUsers={this.loadUsers}
                  handleSelectUser={this.handleSelectUser}
                  handleSendWelcomeEmails={this.handleSendWelcomeEmails}
                />
              </ErrorBoundary>
              <ErrorBoundary>
                <AdminUsersFooter
                  {...this.state}
                  handleChangePage={this.handleChangePage}
                  handleChangePerPage={this.handleChangePerPage}
                />
              </ErrorBoundary>
            </>
          </Container>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  openUserDeactivateModal: (params) => {
    dispatch(showModal('UserDeactivateModal', params));
  },
  openUserActivateModal: (params) => {
    dispatch(showModal('UserActivateModal', params));
  },
  openConfirmationModal: (params) => {
    dispatch(showConfirmationModal(params));
  },
});

AdminUsers.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  openUserDeactivateModal: PropTypes.func.isRequired,
  openUserActivateModal: PropTypes.func.isRequired,
  openConfirmationModal: PropTypes.func.isRequired,
};

export default withRouter(connect(null, mapDispatchToProps)(injectIntl(AdminUsers)));
